import * as t from "io-ts";
import { PostAssetsV } from "@/types/assets";

export const SsrNodeV = t.intersection([
  t.type({
    html: t.string
  }),
  PostAssetsV
]);

// this type also exists in Psalm
export type SsrNode = t.TypeOf<typeof SsrNodeV>;
